import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import { u as useComponentWidth } from './useComponentWidth-f74aea3c.js';
import Icon from './Icon.js';
import { C as Card } from './Card-683c5834.js';
import './_commonjsHelpers-97e6d7b1.js';
import './Title.js';
import './PropTypes-9aad034b.js';
import 'moment';

function Carrousel(props) {
  var className = props.className,
    itemsToShow = props.itemsToShow,
    itemsToMove = props.itemsToMove,
    items = props.items,
    onItemClick = props.onItemClick;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var _useComponentWidth = useComponentWidth(),
    _useComponentWidth2 = _slicedToArray(_useComponentWidth, 2),
    carrouselRef = _useComponentWidth2[0],
    carrouselWidth = _useComponentWidth2[1];
  var carrouselItemsGap = 20;
  var itemWidth = carrouselWidth / itemsToShow + carrouselItemsGap / itemsToShow;
  var itemsWrapperWidth = items.length * itemWidth;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-carrousel-wrapper ".concat(className),
    ref: carrouselRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-carrousel-window"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'bf-carrousel-items-wrapper',
    style: {
      width: itemsWrapperWidth,
      transform: "translate3d(".concat(scrollPosition, "px, 0px, 0px)")
    }
  }, items.map(function (item, index) {
    var key = "CARROUSEL_ITEM_".concat(index);
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      className: "bf-carrousel-item-wrapper",
      style: {
        width: itemWidth
      }
    }, /*#__PURE__*/React__default.createElement(Card, {
      noPadding: true,
      className: "bf-carrousel-item"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "bf-carrousel-item-image",
      onClick: function onClick() {
        onItemClick(index);
      },
      style: {
        backgroundImage: "url(".concat(item.image, ")")
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "bf-carrousel-item-content",
      onClick: function onClick() {
        onItemClick(index);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "bf-carrousel-item-title"
    }, item.title))));
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-carrousel-nav-trigger-wrapper bf-carrousel-nav-trigger-prev"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-carrousel-nav-trigger",
    onClick: function onClick() {
      return setScrollPosition(scrollPosition + itemWidth * itemsToMove);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-angle-left"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-carrousel-nav-trigger-wrapper bf-carrousel-nav-trigger-next"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-carrousel-nav-trigger",
    onClick: function onClick() {
      return setScrollPosition(scrollPosition - itemWidth * itemsToMove);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-angle-right"
  }))));
}
Carrousel.defaultProps = {
  itemsToShow: 4,
  className: '',
  itemsToMove: 1,
  onItemClick: function onItemClick() {}
};
Carrousel.propTypes = {
  /**
  Items array
   */
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  /**
  Items shown at the same time
   */
  itemsToShow: PropTypes.number,
  /**
  Items to move on nav triggers click
   */
  itemsToMove: PropTypes.number,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Dispatch an action when the user clicks on an item
   */
  onItemClick: PropTypes.func
};

export default Carrousel;
